/*
 * @Descripttion:
 * @version:
 * @Author: zhubaodong
 * @Date: 2020-10-09 11:16:06
 * @LastEditors: xuhongwei
 * @LastEditTime: 2023-05-25 17:13:06
 */
//@ts-ignore
/**
 * @description test121的服务都修改网关、服务端控制去proxy_pass为1v1api，此外除了testpc、testpai的所有服务都转为请求1v1api（线上vip1v1）服务
 * 1v1api内网不能直接请求，改为https://test121.meishubao.com/1v1_client_gateway
 */
const env: "dev" | "test" | "live" = import.meta.env.VITE_APP_ENV;
const urlList = {
  dev: "/devapi0",
  test: "https://test121.meishubao.com",
  live: "https://vip.meishubao.com"
};

// const urlList1 = {
//   dev: "https://dstoreapi.meishubao.com",
//   test: "https://tstoreapi.meishubao.com",
//   live: "https://storeapi.meishubao.com"
// };

// const newBaseUrlList = {
//   dev: "https://test121.meishubao.com/1v1_client_gateway",
//   test: "https://test121.meishubao.com/1v1_client_gateway",
//   live: "https://vip.meishubao.com/1v1_client_gateway"
// }

const urlList2 = {
  dev: "https://testapi.meishubao.com",
  test: "https://testapi.meishubao.com",
  live: "https://onlineapi.meishubao.com"
};

const urlList4 = {
  dev: "https://javaapipc.meishubao.com",
  test: "https://testpc.meishubao.com",
  live: "https://onlinepc.meishubao.com"
};

// const urlList5 = {
//   dev: "https://dapivip.meishubao.com",
//   test: "https://tapivip.meishubao.com",
//   live: "https://apivip.meishubao.com"
// };

// const urlList6 = {
//   dev: "https://dmpapi.meishubao.com",
//   test: "https://tmpapi.meishubao.com",
//   live: "https://mpapi.meishubao.com"
// };

// const urlList8 = {
//   dev: "https://devteacher.meishubao.com",
//   test: "https://testteacher.meishubao.com",
//   live: "https://teacher.meishubao.com"
// };

// const urlList9 = {
//   dev: "https://dev121.meishubao.com/aiapi/a/p",
//   test: "https://test121.meishubao.com/aiapi/a/p",
//   live: "https://vip.meishubao.com/aiapi/a/p"
// };

// ! 这样开头的都是走的test121的服务，然后服务端再proxy_pass到各个服务
// const urlList10 = {
//   dev: "/1v1app",
//   test: "/1v1app",
//   live: "/1v1app"
// };
// const urlList11 = {
//   dev: "/aiapi",
//   test: "/aiapi",
//   live: "/aiapi"
// };
const urlList12 = {
  dev: "/duiba",
  test: "/duiba",
  live: "/duiba"
};

const urlList13 = {
  // dev: "https://mscgate-default.meishubao.com",
  // test: "https://mscgate-dev.meishubao.com",
  // live: "https://mscgate.meishubao.com"
  // dev: "/mscgate",
  // test: "/mscgate",
  // live: "/mscgate"
  dev: "/vip-app-dev/api/vipappmscgate/api",
  test: "/vip-app-dev/api/vipappmscgate/api",
  live: "/vip-app-live/api/vipappmscgate/api"
};
// const urlList14 = {
//   dev: "/ums",
//   test: "/ums",
//   live: "/ums"
// };
// 前端服务 不改
const urlList15 = {
  dev: "/gql",
  test: "/gql",
  live: "/gql"
};
// const urlList16 = {
//   // 测试 http://teacherapi-test.meishubao.com
//   // 线上 http://teacherapi.meishubao.com
//   dev: "/teacherapi",
//   test: "/teacherapi",
//   live: "/teacherapi"
// };
const urlList17 = {
  dev: "/1v1app/dbk/api",
  test: "/1v1app/dbk/api",
  live: "/1v1app/dbk/api"
};
const urlList18 = {
  dev: "https://track-dev.meishubao.com",
  test: "https://track-test.meishubao.com",
  live: "https://track.meishubao.com"
};

// 小熊服务 不改
const urlList19 = {
  dev: "/mop",
  test: "/mop",
  live: "/mop"
};

// export const newBaseUrl = newBaseUrlList[env]
export const newBaseUrl = '/1v1_client_gateway'

// 原服务可从上面或者proxy看，注意本地proxy是不生效的！！！如果不是直接请求的完整服务地址如https://testapi.meishubao.com，都是请求的test121服务，服务端再根据前缀匹配、proxy_pass分配到各个服务
export const baseURL = urlList[env] || "/devapi0";
export const baseURL1 = newBaseUrl + '/client/php/store' || "/devapi1";
export const baseURL2 = urlList2[env] || "/devapi2";
export const baseURL4 = urlList4[env] || "/devapi4";
export const baseURL5 = newBaseUrl + '/client/php/c' || "/devapi5";
export const baseURL6_1 = newBaseUrl + '/client/operation_service/operation' || "/devapi6";
export const baseURL6_2 = newBaseUrl + '/client/question_center/question' || "/devapi6";
export const baseURL7 = newBaseUrl + '/logistics/c' || "/devapi7";
export const baseURL8 = newBaseUrl + '/client/tea_management' || "/devapi8";
export const baseURL9 =  newBaseUrl + '/client/ums_api/a/p' || "/devapi9";
export const baseURL10 = '/1v1app' || "/devapiA";
export const baseURL11 = newBaseUrl + '/client/ums_api' || "/devapiB";
export const baseURL12 = urlList12[env] || "/devapiC";
export const baseURL13 = newBaseUrl + urlList13[env] || "/devapiD";
export const baseURL14 = newBaseUrl + '/client/ums_api' || "/devapiE";
export const baseURL15 = urlList15[env] || "/devapiF";
export const baseURL16 = newBaseUrl + '/client/tea_management' || "/devapiG";
export const baseURL17 = urlList17[env] || "/devapiH";
export const baseURL18 = urlList18[env] || "/devapiI";
export const baseURL19 = urlList19[env] || "/devapiJ";
export const baseURL20 = "/yybk8s";
export const newBaseUrlClientPhpBoss = newBaseUrl + '/client/php/boss'
